module.exports = __webpack_public_path__ + "static/media/info.75d70b9f.svg";